<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />
    <!-- <div class="bg-map-white-area" v-show="!newVersion()">
      <div class="row">
        <div class="col-sm-4">
          <br />
          <div class="bg-color-map-green">
            <h4 v-html="LG('SA_heading1')"></h4>
            <br />
            <div v-show="!anyStarsEarned()">
              <p id="id-paragraph1" v-html="LG('SA_paragraph1')"></p>
              <p id="id-paragraph2" v-html="LG('SA_paragraph2')"></p>
            </div>
            <span>
              <font-awesome-icon icon="hand-point-right" class="leave-space" />
              <span id="id-paragraph3" v-html="LG('SA_paragraph3')"></span>
            </span>
            <div v-show="anyStarsEarned()">
              <br />
              <p id="id-paragraph2" v-html="LG('SA_paragraph2')"></p>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <br />
          <div class="map-area">
            <OverlayObjects :overlays="overlaysMap" bg="menus/map/map.png" bgwidth="630" bgheight="450" alt="Un quartier avec plusieurs zones au choix" @object-clicked="onObjectClicked"></OverlayObjects>
            <br />
          </div>
        </div>
      </div>
    </div> -->

    <div v-show="newVersion()">
      <h1 class="text-center title">{{ LG("HP_mapButtonLabel") }}</h1>
      <div class="map-container-new">
        <div class="map-text-bubble-new move-left-a-bit">
          <span>
            <font-awesome-icon icon="hand-point-right" class="leave-space" />
            <span id="id-paragraph3" v-html="LG('SA_paragraph3')"></span>
          </span>
          <!--<div v-show="anyStarsEarned()">-->
          <br aria-hidden="true" />
          <br aria-hidden="true" />
          <p id="id-paragraph2" v-html="LG('SA_paragraph2')"></p>
          <!--</div>-->
        </div>
        <div class="map-area-new">
          <BlocNoteAndBtn class="bloc-note-btn" />
          <OverlayObjects :overlays="overlaysMap3D" map="yes" :bg="getMapBG()" bgwidth="1280" bgheight="540" alt="Un quartier avec plusieurs zones au choix" @object-clicked="onObjectClicked" @first-rollover="onFirstRollover()"></OverlayObjects>
          <br aria-hidden="true" />
        </div>
      </div>
    </div>
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <AudioPlayer id="id-areamusicaudio" ref="musicBGRef" volume="0.4" loop="yes" autoplay="yes" :url="musicAudio"></AudioPlayer>
    <AudioPlayer id="id-areaaudio" :url="getIntroAudio()" registered="yes" @audio-ended="onAudioEnded()" autoplay="yes"></AudioPlayer>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import OverlayObjects from "../components/OverlayObjects.vue";
import AudioPlayer from "../components/AudioPlayer.vue";
import BlocNoteAndBtn from "../components/BlocNoteAndBtn.vue";

export default {
  components: {
    ProgressBars,
    OverlayObjects,
    AudioPlayer,
    BlocNoteAndBtn,
  },
  data() {
    return {
      overlaysMap3D: [
        {
          id: "id-area1",
          x: 0,
          y: 0,
          width: 1280,
          hotspots: [
            {
              id: "id-area1-1",
              x: 619,
              y: 207,
              w: 226,
              h: 179,
            },
          ],
          image: "menus/map3d/map_ONyVa.png",
          isMouseOver: false,
          alt: "SA_altAreaSection1",
          underconstruction: false,
          area: 0,
          loaded: false,
          rounded: true,
        },
        {
          id: "id-area2",
          x: 0,
          y: 0,
          width: 1280,
          hotspots: [
            {
              id: "id-area2-1",
              x: 213,
              y: 100,
              w: 223,
              h: 202,
            },
          ],
          image: "menus/map3d/map_SEE.png",
          isMouseOver: false,
          alt: "SA_altAreaSection2",
          underconstruction: false,
          area: 1,
          loaded: false,
          rounded: true,
        },
        {
          id: "id-area3",
          x: 0,
          y: 0,
          width: 1280,
          hotspots: [
            {
              id: "id-area3-1",
              x: 873,
              y: 11,
              w: 278,
              h: 247,
            },
          ],
          image: "menus/map3d/map_school.png",
          isMouseOver: false,
          alt: "SA_altAreaSection3",
          underconstruction: false,
          area: 2,
          loaded: false,
          rounded: true,
        },
        {
          id: "id-area4",
          x: 0,
          y: 0,
          width: 1280,
          hotspots: [
            {
              id: "id-area4-1",
              x: 392,
              y: 347,
              w: 212,
              h: 150,
            },
          ],
          image: "menus/map3d/map_house.png",
          isMouseOver: false,
          alt: "SA_altAreaSection4",
          underconstruction: false,
          area: 3,
          loaded: false,
          rounded: true,
        },
        {
          id: "id-stars-1",
          x: 624,
          y: 304,
          width: 138,
          image: "menus/map3d/3stars0.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        {
          id: "id-stars-2",
          x: 188,
          y: 212,
          width: 147,
          image: "menus/map3d/3stars0.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        {
          id: "id-stars-3",
          x: 839,
          y: 203,
          width: 140,
          image: "menus/map3d/3stars0.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        {
          id: "id-stars-4",
          x: 392,
          y: 417,
          width: 132,
          image: "menus/map3d/3stars0.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        //{
        //    id: "id-stars-1a",
        //    x: 649,
        //    y: 324,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //},
        //{
        //    id: "id-stars-1b",
        //    x: 687,
        //    y: 346,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //},
        //{
        //    id: "id-stars-2a",
        //    x: 197,
        //    y: 219,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //},
        //{
        //    id: "id-stars-2b",
        //    x: 233,
        //    y: 239,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //},
        //{
        //    id: "id-stars-2c",
        //    x: 270,
        //    y: 260,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //},
        //{
        //    id: "id-stars-3a",
        //    x: 868,
        //    y: 213,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //},
        //{
        //    id: "id-stars-3b",
        //    x: 906,
        //    y: 235,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //},
        //{
        //    id: "id-stars-4a",
        //    x: 434,
        //    y: 444,
        //    width: 40,
        //    image: "menus/map3d/star.png",
        //    selectable: "no",
        //    visible: "no",
        //    loaded: false,
        //}
      ],

      // Arrays
      overlaysMap: [
        {
          id: "id-area1",
          x: 240,
          y: 165,
          width: 225,
          hotspots: [
            {
              id: "id-area1-1",
              x: 240,
              y: 165,
              w: 225,
              h: 120,
            },
          ],
          image: "menus/map/map_area1.png",
          rollover: "menus/map/map_area1_active.png",
          isMouseOver: false,
          alt: "SA_altAreaSection1",
          underconstruction: false,
          area: 0,
          loaded: false,
        },
        {
          id: "id-area2",
          x: 189,
          y: 38,
          width: 112,
          hotspots: [
            {
              id: "id-area2-1",
              x: 189,
              y: 38,
              w: 112,
              h: 151,
            },
          ],
          image: "menus/map/map_area2.png",
          rollover: "menus/map/map_area2_active.png",
          isMouseOver: false,
          alt: "SA_altAreaSection2",
          underconstruction: false,
          area: 1,
          loaded: false,
        },
        {
          id: "id-area3",
          x: 437,
          y: 38,
          width: 152,
          hotspots: [
            {
              id: "id-area3-1",
              x: 437,
              y: 38,
              w: 152,
              h: 126,
            },
          ],
          image: "menus/map/map_area3.png",
          rollover: "menus/map/map_area3_active.png",
          isMouseOver: false,
          alt: "SA_altAreaSection3",
          underconstruction: false,
          area: 2,
          loaded: false,
        },
        {
          id: "id-area4",
          x: 40,
          y: 260,
          width: 252,
          hotspots: [
            {
              id: "id-area4-1",
              x: 40,
              y: 260,
              w: 252,
              h: 152,
            },
          ],
          image: "menus/map/map_area4.png",
          rollover: "menus/map/map_area4_active.png",
          isMouseOver: false,
          alt: "SA_altAreaSection4",
          underconstruction: false,
          area: 3,
          loaded: false,
        },
        {
          id: "id-stars-1",
          x: 305,
          y: 275,
          width: 67,
          image: "icons/stars-2.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        {
          id: "id-stars-2",
          x: 205,
          y: 140,
          width: 79,
          image: "icons/stars-3.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        {
          id: "id-stars-3",
          x: 485,
          y: 144,
          width: 67,
          image: "icons/stars-2.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        {
          id: "id-stars-4",
          x: 100,
          y: 380,
          width: 68,
          image: "icons/stars-1.png",
          selectable: "no",
          visible: "yes",
          loaded: false,
        },
        {
          id: "id-stars-1a",
          x: 312,
          y: 275,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
        {
          id: "id-stars-1b",
          x: 345,
          y: 275,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
        {
          id: "id-stars-2a",
          x: 210,
          y: 140,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
        {
          id: "id-stars-2b",
          x: 235,
          y: 140,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
        {
          id: "id-stars-2c",
          x: 260,
          y: 140,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
        {
          id: "id-stars-3a",
          x: 493,
          y: 145,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
        {
          id: "id-stars-3b",
          x: 525,
          y: 145,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
        {
          id: "id-stars-4a",
          x: 124,
          y: 380,
          width: 19,
          image: "icons/star.png",
          selectable: "no",
          visible: "no",
          loaded: false,
        },
      ],

      //MES1 - Centre ONY VA
      //MES2 - Service de Garde
      //MES3 - École
      //MES4 - Domicile(home)
      //MES5 - École
      //MES6 - Centre ONYVA
      //MES7 - Service de Garde
      //MES8 - Service de Garde
      starList: [8, 10, 13, 15, 14, 9, 11, 12],

      // Images
      starImage: require("@/assets/icons/star.png"),
      starImageGray: require("@/assets/icons/starGray.png"),

      mapBG: "menus/map3d/map.png",
      mapBGDark: "menus/map3d/map_dark.png",

      // Audio
      introAudioShort: "/audio/partager/partager_carte_court.mp3",
      introAudioLong: "/audio/partager/partager_carte_long.mp3",
      musicAudio: "/audio/partager/music.mp3",

      // Variables
      firstRolloverOccurred: false,
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (this.newVersion()) {
      this.revealStarsNew();
    } else {
      this.revealStars();
    }
  },
  methods: {
    getMapBG() {
      if (this.firstRolloverOccurred) {
        return this.mapBGDark;
      }
      return this.mapBG;
    },
    onAudioEnded() {
      // When voice over ends (and not muted), boost up music volume - TBD make this gradual
      if (!this.$store.state.gamestate.muted) {
        var audioRef = this.$refs["musicBGRef"];
        if (audioRef != null) {
          audioRef.setVolume(1);
        } else {
          console.log("Failed to set volume on null musicBGRef!");
        }
      }
    },
    getIntroAudio() {
      //// If user has not earned any stars yet, do the long audio, else the short
      //if (this.anyStarsEarned()) {
      //    return this.introAudioShort;
      //} else {
      //    return this.introAudioLong;
      //}

      // Johanne's CQ asks that we never bother with the long one at all
      return this.introAudioShort;
    },
    anyStarsEarned() {
      for (var i = 0; i < this.starList.length; i++) {
        if (this.$store.state.gamestate.completed[i] == true) {
          return true;
        }
      }
      return false;
    },
    revealStarsNew() {
      //MES1 - Centre ONY VA
      //MES2 - Service de Garde
      //MES3 - École
      //MES4 - Domicile(home)
      //MES5 - École
      //MES6 - Centre ONYVA
      //MES7 - Service de Garde
      //MES8 - Service de Garde
      var AREA1_stars = 0; // Centre ONY VA
      var AREA2_stars = 0; // Service de Garde
      var AREA3_stars = 0; // École
      var AREA4_stars = 0; // Domicile

      for (var i = 0; i < 12; i++) {
        if (this.$store.state.gamestate.completed[i] == true) {
          if (i == 0 || i == 5 || i == 10) {
            AREA1_stars++;
          }
          if (i == 1 || i == 6 || i == 7) {
            AREA2_stars++;
          }
          if (i == 2 || i == 4 || i == 9) {
            AREA3_stars++;
          }
          if (i == 3 || i == 8 || i == 11) {
            AREA4_stars++;
          }
        }
      }

      //AREA1_stars = 2;
      //AREA2_stars = 3;
      //AREA3_stars = 2;
      //AREA4_stars = 1;

      if (AREA1_stars == 0) {
        this.overlaysMap3D[4].image = "menus/map3d/3stars0.png";
      } else if (AREA1_stars == 1) {
        this.overlaysMap3D[4].image = "menus/map3d/3stars1.png";
      } else if (AREA1_stars == 2) {
        this.overlaysMap3D[4].image = "menus/map3d/3stars2.png";
      } else if (AREA1_stars == 3) {
        this.overlaysMap3D[4].image = "menus/map3d/3stars3.png";
      }

      if (AREA2_stars == 0) {
        this.overlaysMap3D[5].image = "menus/map3d/3stars0.png";
      } else if (AREA2_stars == 1) {
        this.overlaysMap3D[5].image = "menus/map3d/3stars1.png";
      } else if (AREA2_stars == 2) {
        this.overlaysMap3D[5].image = "menus/map3d/3stars2.png";
      } else if (AREA2_stars == 3) {
        this.overlaysMap3D[5].image = "menus/map3d/3stars3.png";
      }

      if (AREA3_stars == 0) {
        this.overlaysMap3D[6].image = "menus/map3d/3stars0.png";
      } else if (AREA3_stars == 1) {
        this.overlaysMap3D[6].image = "menus/map3d/3stars1.png";
      } else if (AREA3_stars == 2) {
        this.overlaysMap3D[6].image = "menus/map3d/3stars2.png";
      } else if (AREA3_stars == 3) {
        this.overlaysMap3D[6].image = "menus/map3d/3stars3.png";
      }

      if (AREA4_stars == 0) {
        this.overlaysMap3D[7].image = "menus/map3d/3stars0.png";
      } else if (AREA4_stars == 1) {
        this.overlaysMap3D[7].image = "menus/map3d/3stars1.png";
      } else if (AREA4_stars == 2) {
        this.overlaysMap3D[7].image = "menus/map3d/3stars2.png";
      } else if (AREA4_stars == 3) {
        this.overlaysMap3D[7].image = "menus/map3d/3stars3.png";
      }
    },
    revealStars() {
      for (var i = 0; i < this.starList.length; i++) {
        var index = Number(this.starList[i]);
        if (this.$store.state.gamestate.completed[i] == true) {
          this.getOverlay(index).visible = "yes";
        } else {
          this.getOverlay(index).visible = "no";
        }
      }
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    IsSituation(index) {
      if (index == this.getCurrentSituation()) {
        return true;
      }
      return false;
    },
    onObjectClicked(index) {
      var overlay = this.getOverlay(index);

      if (overlay.underconstruction) {
        alert(this.LG("G_underconstruction"));
      } else {
        // The area is valid, so move on to situations page
        let actName = this.getAreaNameFromAreaIndex(overlay.area);
        this.$router.push(`/${actName}/situations`);
      }
    },
    onFirstRollover() {
      this.firstRolloverOccurred = true;
    },
    getOverlay(index) {
      if (this.newVersion()) {
        return this.overlaysMap3D[index];
      } else {
        return this.overlaysMap[index];
      }
    },
  },
};
</script>

<style scoped>
h1.title {
  text-align: center;

  margin-top: 5px;
  margin-bottom: 25px;

  font-family: "Poppins";
  color: #333;
}
.bloc-note-btn {
  position: absolute;
  top: 15%;
  right: -20px;
  z-index: 3;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");
@import url("https://fonts.googleapis.com/css?family=Nunito");

.bg-map-white-area {
  background-color: white;
  color: black;
  max-width: 1000px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.map-container-new {
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 0;
}

.map-area {
  margin-top: 10px;
  margin-right: 25px;
  padding-right: 10px;
  padding-left: 0px;
}

.map-area-new {
  position: relative;
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.move-left-a-bit {
  /*right: 77% !important;*/
  top: 53% !important;
}

.map-text-bubble-new {
  position: absolute;
  top: 10%;
  left: 0px;
  max-width: 400px;
  background-color: #e8eff2;
  color: black;
  font-weight: bold;
  font-family: "Nunito";
  font-size: 17px;
  border-radius: 40px;
  border: 10px solid #ffffff;
  padding: 25px;
  z-index: 1;
}

.map-text-bubble-new a:link {
  color: #0563c1 !important;
  text-decoration: none !important;
}

.map-text-bubble-new a:visited {
  color: #0563c1 !important;
  text-decoration: none !important;
}

.map-text-bubble-new a:hover {
  color: #004a7f !important;
}

.map-text-bubble-new a:active {
  color: #155168 !important;
}

.bg-color-map-green {
  background-color: #3f5d12;
  border: 1px solid #8cbbe9;
  padding: 14px;
  color: white;
  min-height: 450px;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 0px;
  font-family: "Nunito";
  font-size: 17px;
}

@media only screen and (max-width: 1300px) {
  .map-text-bubble-new {
    position: relative;
    top: 30px;
    left: 0px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 1000px;
    font-size: 22px !important;
  }

  .map-area-new {
    padding-top: 50px;
  }
}

@media only screen and (max-width: 600px) {
  .map-area {
    padding-left: 20px !important;
    margin-right: 15px;
  }

  .bg-color-map-green {
    margin-right: 20px !important;
  }
}

.star-display {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 12px;
}
</style>
